import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/expeditedssl': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zM150.6 176.3C150.6 122.6 194.3 78.9 248 78.9S345.4 122.6 345.4 176.3V202.9C345.4 207.9 341.5 211.8 336.5 211.8H318.8C313.8 211.8 309.9 207.9 309.9 202.9V176.3C309.9 94.2 185.9 94.2 185.9 176.3V202.9C185.9 207.9 182 211.8 177 211.8H159.3C154.3 211.8 150.4 207.9 150.4 202.9V176.3zM389.7 380C389.7 389.7 381.7 397.7 372 397.7H124C114.3 397.7 106.3 389.7 106.3 380V238.3C106.3 228.6 114.3 220.6 124 220.6H372C381.7 220.6 389.7 228.6 389.7 238.3V380zM141.7 242.7V375.6C141.7 378.1 139.8 380 137.3 380H128.4C125.9 380 124 378.1 124 375.6V242.7C124 240.2 125.9 238.3 128.4 238.3H137.3C139.8 238.3 141.7 240.2 141.7 242.7zM283.4 291.4C283.4 304.4 276.2 315.8 265.7 321.8V353.4C265.7 358.4 261.8 362.3 256.8 362.3H239.1C234.1 362.3 230.2 358.4 230.2 353.4V321.8C219.7 315.7 212.5 304.4 212.5 291.4 212.5 271.7 228.3 256 247.9 256S283.4 271.8 283.4 291.4zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 486.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/expeditedssl.js
// module id = H9mG
// module chunks = 144